// src/components/Confetti.tsx
import React from "react";

type ConfettiProps = {
  show: boolean;
  count?: number;
  duration?: number; // ms
};

export function Confetti({ show, count = 100, duration = 1000 }: ConfettiProps) {
  if (!show) return null;

  // Precompute target offsets for each piece (center burst)
  const pieces = Array.from({ length: count }).map((_, i) => {
    const angle = Math.random() * Math.PI * 2;           // 0..2π
    const radius = 80 + Math.random() * 160;             // px distance
    const x = Math.cos(angle) * radius;
    const y = Math.sin(angle) * radius;
    const delay = Math.random() * 120;                    // ms
    const size = 6 + Math.random() * 6;                   // px
    const rotate = Math.floor(Math.random() * 720);       // deg
    const hue = Math.floor(Math.random() * 360);          // color
    return { x, y, delay, size, rotate, hue, key: i };
  });

  return (
    <div className="confetti-burst" aria-hidden="true">
      {pieces.map(p => (
        <span
          key={p.key}
          className="confetti-dot"
          style={{
            // custom properties for CSS animation
            ['--x' as any]: `${p.x}px`,
            ['--y' as any]: `${p.y}px`,
            ['--dur' as any]: `${duration}ms`,
            ['--del' as any]: `${p.delay}ms`,
            ['--rot' as any]: `${p.rotate}deg`,
            ['--size' as any]: `${p.size}px`,
            ['--h' as any]: `${p.hue}`,
          }}
        />
      ))}
    </div>
  );
}
